import { render, staticRenderFns } from "./CountBadge.vue?vue&type=template&id=5c868727&functional=true&"
import script from "./CountBadge.vue?vue&type=script&lang=js&"
export * from "./CountBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports